import { Alert, Snackbar } from '@mui/material';
import { useActions } from 'hooks/useActions';
import { createContext, useState, useEffect, useContext } from 'react';
import { useLocation } from 'react-router-dom';

interface MessageContextType {
  message: string | null;
}

const MessageContext = createContext<MessageContextType | undefined>(undefined);

export const useMessage = (): MessageContextType => {
  const context = useContext(MessageContext);
  if (!context) {
    throw new Error('useMessage must be used within a MessageProvider');
  }
  return context;
};

export const MessageProvider = ({ children }: any) => {
  const { state } = useLocation();
  const { clearErrors } = useActions();
  const [message, setMessage] = useState<string | null>(null);

  useEffect(() => {
    setMessage(state?.message);
    if (state?.message) {
      clearErrors();
    }
    const timer = setTimeout(() => {
      window.history.replaceState({}, '');
      setMessage(null);
    }, 5000);

    return () => clearTimeout(timer);
  }, [state]);

  return (
    <MessageContext.Provider value={{ message }}>
      {children}

      <Snackbar open={!!message} anchorOrigin={{ vertical: 'top', horizontal: 'center'}} style={{ marginTop: '5rem'}}>
        <Alert severity="success" variant="filled" sx={{ width: '100%' }}>
          {message}
        </Alert>
      </Snackbar>
    </MessageContext.Provider>
  );
};
